import React from 'react';
import { ActionsMenu } from '../AccountsUsers/ActionsMenu';
import { deployStatusLabel, formatDate, formatLimit, storeInkUrl } from './constants';

function estadoLabel(store) {
    if (store.biblio_active !== 1) {
        return { label: 'Pausada', className: 'status-off' };
    }
    const deploy = Number(store.biblio_status_deploy);
    if (deploy === 2) {
        return { label: 'En despliegue', className: 'status-warning' };
    }
    if (deploy === 1) {
        return { label: 'Activa', className: 'status-on' };
    }
    return { label: 'Sin desplegar', className: 'status-off' };
}

export function BiblioTable({ stores, onEdit, onPause, onDeploy, onDelete }) {
    if (!stores || stores.length === 0) {
        return (
            <div className="text-center py-5 text-white-50">
                <h6 className="m-0 opacity-50">No se encontraron tiendas para los filtros aplicados</h6>
            </div>
        );
    }

    return (
        <div className="modern-table-container">
            <table className="modern-table striped-table">
                <thead>
                    <tr>
                        <th>Cuenta</th>
                        <th>Plan</th>
                        <th>Vigencia</th>
                        <th>URL</th>
                        <th>Estado</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {stores.map((store) => {
                        const registered = store.registered === 1;
                        const statusDeploy = Number(store.biblio_status_deploy);
                        const isActive = store.biblio_active === 1;
                        const deployed = statusDeploy === 1;
                        const estado = registered
                            ? estadoLabel(store)
                            : { label: deployStatusLabel(store.biblio_status_deploy), className: 'status-off' };

                        const items = [];
                        if (registered) {
                            items.push({ label: 'Editar', onClick: () => onEdit(store) });
                            if (deployed && isActive) {
                                items.push({ label: 'Pausar', onClick: () => onPause(store) });
                            } else if (!isActive) {
                                items.push({ label: 'Activar', onClick: () => onPause(store) });
                            }
                            if (!deployed && isActive) {
                                items.push({ label: 'Desplegar', onClick: () => onDeploy(store) });
                            }
                            items.push({ label: 'Eliminar', danger: true, onClick: () => onDelete(store) });
                        } else {
                            items.push({ label: 'Registrar tienda', onClick: () => onEdit(store) });
                        }

                        return (
                            <tr key={store.id_pub}>
                                <td className="short fw-bold text-white">
                                    <span className="badge-status me-2">{store.prefix}</span>
                                    {store.account}
                                </td>
                                <td className="short text-white-50">
                                    {registered
                                        ? `${formatLimit(store.titles_limit)} títulos / ${formatLimit(store.users_limit)} usuarios`
                                        : '—'}
                                </td>
                                <td className="short text-white-50">
                                    {registered
                                        ? `${formatDate(store.deploy_date)} → ${formatDate(store.date_end)}`
                                        : '—'}
                                </td>
                                <td className="short text-white-50">{storeInkUrl(store.prefix) || '—'}</td>
                                <td className="short">
                                    <span className={`badge-status ${estado.className}`}>
                                        {estado.label}
                                    </span>
                                </td>
                                <td>
                                    <ActionsMenu items={items} title="Acciones de la tienda" />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default BiblioTable;
